<div class="view-comments-modal" role="dialog" aria-modal="true">
  <div class="modal-header">
    <h2>View/Add Comments</h2>
    <button type="button" class="icon-btn" aria-label="Close" (click)="onClose()">&times;</button>
  </div>


  <ng-container *ngIf="data?.record?.allComments?.length > 0; else noComments">
    <div class="comments-list" style="max-height: 120px; overflow-y: auto;">
      <div class="comment-block" *ngFor="let c of data.record.allComments">
        <div class="comment-author">
         <span class="comment-employee">{{ c.createdBy || data.record.employee }}</span> 
          <span class="comment-date">{{ c.createdDate | date:'MM/dd/yy' }}</span>
        </div>
        <div class="comment-text">
          {{ c.commentText }}
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noComments>
    <ng-container *ngIf="data?.record?.comments?.length > 0; else noComments">
      <div class="comments-list" style="max-height: 120px; overflow-y: auto;">
        <div class="comment-block" *ngFor="let record of data.record.comments">
          <div class="comment-author">
           <span class="comment-employee">{{ record.createdByName ? record.createdByName : record.createdBy }}</span>  
            <span class="comment-date">{{ record.createdDate | date:'MM/dd/yy' }}</span>
          </div>
          <div class="comment-text">
            {{ record?.comment }}
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #noComments>
    <p class="no-comments">No comments added yet.</p>
  </ng-template>

  <div class="modal-footer">
    <app-button-group
      [label]="'Add Comments'"
      [buttonType]="'Secondary'"
      [cssClass]="'btn btn-secondary'"
      (click)="onAddComments()"
    ></app-button-group>
  </div>
</div>